// extracted by css-extract-rspack-plugin
export default {"exactPriceBlock":"exactPriceBlock-rXsylg","exactPriceBlockContent":"exactPriceBlockContent-nFUSBC"};